<template>
  <div class="enrolling-student-list">
    <PlatDataGridSiteUnit grid-id="PeEnrollStudent"
                          show-label></PlatDataGridSiteUnit>
  </div>
</template>

<script>
import PlatDataGridSiteUnit from '../../../wrapper/grid/PlatDataGridSiteUnit'
export default {
  name: 'EnrollingStudentList',
  components: {
    PlatDataGridSiteUnit
  }
}
</script>

<style lang="scss">
  .enrolling-student-list {
    height: 100%;
  }
</style>
